import { Injectable } from '@angular/core';
import { InspectionFactoryService } from '../../shared/services/inspectionFactory.service';
import { IndexedDbService } from '../../shared/services/indexedDb.service';
import { Observable } from 'rxjs';
import { DataService } from '../../shared/services';
import { map } from 'rxjs/operators';

@Injectable()
export class ContactPluginFactoryService extends InspectionFactoryService {
  constructor(indexedDb: IndexedDbService, dataService: DataService) {
    super(indexedDb, dataService);
  }

  public updateContact(inspectionId: string, pluginId: string, contact: any): Observable<any> {
    if (this.isManager) {
      return this.dataService.getPlugin(inspectionId, pluginId).pipe(
        map((plugin) => {
          if (plugin) {
            plugin.config = contact;
            return plugin;
          }
        })
      );
    }
    return this.getInspection(inspectionId).pipe(
      map((inspection) => {
        const plugin = inspection.allPlugins.find((p) => p.id === pluginId);
        if (plugin) {
          plugin.config = contact;
          if (inspection.data) {
            inspection.data.contact = contact;
          }
          plugin.etag = new Date();
          this.updateInspection(inspection);
          return plugin;
        }
        return null;
      })
    );
  }
}
